import { useRoutes } from "react-router-dom";
import DefaultLayout from "../layouts/DefaultLayout";
import Contact from "../pages/Contact/Contact";
import Introduction from "../pages/Introduction/Introduction";
import Products from "../pages/Products/Products";
import SetMenu from "../pages/SetMenu/SetMenu";
import Home from "../pages/Home/Home";
import Chef from "../pages/Chef/Chef";

const routers = [
  {
    path: "/",
    element: <DefaultLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      { path: "/Lien-he", element: <Contact /> },
      { path: "/Gioi-thieu", element: <Introduction /> },
      { path: "/San-pham", element: <Products /> },
      { path: "/Set-thuc-don", element: <SetMenu /> },
      { path: "/Dau-bep", element: <Chef /> },
    ],
  },
  {
    path: "*",
    element: (
      <h1 variant="h4">
        404 <br /> Trang wed không tồn tại
      </h1>
    ),
  },
];

export default function Routers() {
  return useRoutes(routers);
}
